const itinerary = {
    scrollToContinue: 'Scroll om door te gaan',
    expand: 'Uitklappen',
    closeMediaViewer: 'Sluit media viewer',
    previousMedia: 'Vorige media',
    nextMedia: 'Volgende media',
    pdfDownload: 'Download de PDF versie met meer details over de reis',
    pdfEnglish: 'in het Engels',
    pdfDutch: 'in het Nederlands',
    pdfAnd: 'en',
    contactInfo: 'Voor meer informatie kun je rechtstreeks contact opnemen met ons personeel via',
    contactForm: 'contactformulier',
    contactEmail: 'of door een e-mail te sturen naar',
    contactEmailAddress: 'info@ladolcevitareis.nl'
};

export default itinerary;

